import { Alert, Typography } from '@mui/material'
// Not through the barrel: it also exports FirebaseAuthGuard, which imports this
// screen — so the barrel would close a dependency cycle.
import CentredPanel from '@playground/components/CentredPanel'

import AdminSignInForm from './AdminSignInForm'
import { isAdminSignInPath } from './adminSignInPath'
import PartnerSignInForm from './PartnerSignInForm'

/**
 * Partners land on `/` and see only the email-link form; the admin password
 * form lives at `/admin`, a path no partner is ever sent. Sign-in is not a
 * route — the auth guard renders this in place of the router — so the path is
 * read directly.
 */
const SignInScreen = ({ error }: { error?: string | null }) => {
  const isAdmin = isAdminSignInPath(window.location.pathname)

  return (
    <CentredPanel>
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
        {isAdmin ? 'Playground' : 'Zealth for partners'}
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {isAdmin ? <AdminSignInForm /> : <PartnerSignInForm />}
    </CentredPanel>
  )
}

export default SignInScreen
